import React, { useEffect, useState } from 'react';
import { FaCrown, FaMapMarkerAlt } from 'react-icons/fa';
import styles from './brunafurnielstore.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import PerfilLogo from './src/perfil.png';

const BTN_TEXT = '#FFFFFF';

const INSTAGRAM_URL = 'https://www.instagram.com/brunafurnielstore?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';

const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';

type ModalKind = 'whatsapp' | 'vip' | 'maps';

const STORES = [
    {
        id: 'barretos',
        name: 'Barretos',
        whatsapp: `https://wa.me/5517996782065?text=${encodeURIComponent(WHATSAPP_MSG)}`,
        vip: 'https://chat.whatsapp.com/KJtYABOSxpaHNXhhFqOmfb?s=sw&p=i&ilr=4',
        maps: 'https://maps.app.goo.gl/7Z9uAYUoPYy9fkJ69',
    },
    {
        id: 'riopreto',
        name: 'São José do Rio Preto',
        whatsapp: 'https://wa.me/message/F3QG23SIDFCDA1',
        vip: 'https://chat.whatsapp.com/HDYJVrbIA3U5uuJIMNhjLV?s=cl&p=i&mlu=0&ilr=4',
        maps: 'https://maps.app.goo.gl/RXR88E87g7PbJjsRA',
    },
] as const;

const MODAL_COPY: Record<ModalKind, { eyebrow: string; title: string }> = {
    whatsapp: { eyebrow: 'WhatsApp', title: 'Escolha a loja' },
    vip: { eyebrow: 'Grupo VIP', title: 'Escolha a loja' },
    maps: { eyebrow: 'Localização', title: 'Escolha a loja' },
};

const Brunafurnielstore: React.FC = () => {
    const [activeModal, setActiveModal] = useState<ModalKind | null>(null);

    useEffect(() => {
        if (!activeModal) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveModal(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeModal]);

    return (
        <div className={styles.brunafurnielstore}>
            <div className={styles['body-thunder']}>
                <div className={styles['container-thunder']}>
                    <div className={styles.profileStack}>
                        <img
                            src={PerfilLogo}
                            className={styles['img-perfil']}
                            alt="Bruna Furniel Store"
                        />
                        <div className={styles.links}>
                            <a
                                href={INSTAGRAM_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <InstagramIcon height="24" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>INSTAGRAM</span>
                            </a>
                            <button
                                type="button"
                                className={styles.linkButton}
                                onClick={() => setActiveModal('whatsapp')}
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <WhatsappIcon height="30" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>WHATSAPP</span>
                            </button>
                            <button
                                type="button"
                                className={styles.linkButton}
                                onClick={() => setActiveModal('vip')}
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <FaCrown size="22" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>GRUPO VIP</span>
                            </button>
                            <button
                                type="button"
                                className={styles.linkButton}
                                onClick={() => setActiveModal('maps')}
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <FaMapMarkerAlt size="22" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>LOCALIZAÇÃO</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {activeModal ? (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveModal(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="brunafurnielstore-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveModal(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        <p className={styles.modalEyebrow}>{MODAL_COPY[activeModal].eyebrow}</p>
                        <h2 id="brunafurnielstore-modal-title" className={styles.modalTitle}>
                            {MODAL_COPY[activeModal].title}
                        </h2>
                        <div className={styles.modalStores}>
                            {STORES.map((store) => (
                                <a
                                    key={store.id}
                                    href={store[activeModal]}
                                    className={styles.modalStoreBtn}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setActiveModal(null)}
                                >
                                    {store.name}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Brunafurnielstore;
